const outlookMeet = {

    readAsync: function (property, errorMessage, meeting, builder) {
        meeting[property].getAsync(function (result) {
            if (result.status === "failed" || result.value == '' )
                builder.validateMessage = errorMessage;
            else
                builder.meetingParams[property] = result.value;
            builder.checkValidation(property);
        })
    },

    readSubject: function(meeting, builder, err_msg) {
        this.readAsync('subject', err_msg, meeting, builder );
    },

    readStart: function(meeting, builder, err_msg) {
        this.readAsync('start', err_msg, meeting, builder );
    },

    readEnd: function(meeting, builder, err_msg) {
        this.readAsync('end', err_msg, meeting, builder );
    },

    readOptionalAttendes: function(meeting, builder) {
        meeting['optionalAttendees'].getAsync(function (result) {
            if (result.status === "failed")
                builder.validateMessage = errorMessage;
            else
                var values = result.value.map(item => item.emailAddress);
                builder.meetingParams['optionalAttendees'] = values;
            builder.checkValidation('optionalAttendees');
        })
    },

    readRequiredAttendes: function(meeting, builder, exclude) {
        meeting['requiredAttendees'].getAsync(function (result) {
            if (result.status === "failed")
                builder.validateMessage = errorMessage;
            else {
                var values = result.value.map(item => item.emailAddress);
                builder.meetingParams['requiredAttendees'] = values.filter(item => item != exclude);
            }
            builder.checkValidation('requiredAttendees');
        })
    }
}


export default outlookMeet;


// WEBPACK FOOTER //
// ./src/helpers/outlook-meet.js